<template>
	<div class="system-auth">
		<div class="layout-div boxBlock">
			<div class="layout-div-content">
				<el-row>
					<el-col :span="8">
						<span class="visible-set">
							<i class="iconfont iconquanxian"></i>
							权限管理
						</span>
					</el-col>
					<el-col :span="16" class="textR flex-col">
						<el-input placeholder="请输入用户名称" v-model.trim="queryInfo.userName" class="input-with-select searchinput">
							<el-button @click="searchData" slot="append" type="primary" class="thmeBackColor borderColor searchbtn">
								<i class="iconfont iconseach seach-icon"></i>
								搜 索
							</el-button>
						</el-input>
					</el-col>
				</el-row>
				<div class="divid-line"></div>
				<div v-loading="loading" element-loading-spinner="el-icon-loading" class="table-div">
					<el-table :data="authList" style="width:100%;" stripe border :header-cell-style="{ background: '#e7ecf2', color: '#0092f1' }">
						<el-table-column type="index" width="170" label="序号" header-align="center" align="center"></el-table-column>
						<el-table-column prop="userName" header-align="center" align="center" label="用户"></el-table-column>
                        <el-table-column align="center" label="只读限制">
<!--                            <el-table-column align="center" label="专题限制">-->
							<template slot-scope="scope">
								<el-radio-group v-model="scope.row.readOnly" size="small" @change="radioChange(scope.row)">
									<el-radio :label="0" ><i  class="iconfont iconshifou"></i> 非只读</el-radio>
									<el-radio :label="1" ><i  class="iconfont iconshifou"></i> 只读</el-radio>
<!--									<el-radio :label="2" ><i  class="iconfont iconshifou"></i> 非只读</el-radio>-->
								</el-radio-group>
							</template>
						</el-table-column>
					</el-table>
					<div class="nodata table-nodata" v-if="pageInfo.totalRows === 0">
						<div class="nodataImg">
							<div class="textC "><i class="iconfont iconwushuju wushuju-icon"></i></div>
							<div class="textC font14 nodataText">暂无数据！</div>
						</div>
					</div>
				</div>

				<div class="list-footer">
					<el-row class="flex-center">
						<el-col :span="8" class="total-col">
							共
							<span class="total-color">{{ pageInfo.totalPages }}</span>
							页
						</el-col>
						<el-col :span="16" class="textR flexcol">
							<el-pagination
								:current-page="pageInfo.pageNo"
								:total="pageInfo.totalRows"
								@current-change="handlePageNoChange"
								background
								layout="prev, pager, next,jumper"
								:pager-count="5"
							></el-pagination>
							<el-button class="go-btn">GO</el-button>
						</el-col>
					</el-row>
				</div>
			</div>
		</div>
		<closed-prop2 ref="closedProp2"></closed-prop2>
	</div>
</template>

<script>
	import authApi from '@/api/readonly'

	export default {
		name: 'AuthManage',
		components: {},
		data() {
			return {
				searchText: '',
				loading: false,
				authList: [],
				queryInfo:{
					userName:"",
					pageNo: 1
				},
				pageInfo: {
					totalRows: 1,
					totalPages: 6,
					pageNo: 1
				},
				radio3: '1'
			};
		},

		mounted() {
			if (this.$cookies.get("userInfo")) {
				this.userInfo = this.$cookies.get("userInfo")
				// if(this.userInfo.ifback === 1){

				// }
			} else {
				this.$router.go(0)
			}
			this.initData()
		},
		methods: {
			initData: function () {
				this.getPageData()
			},
			searchData: function () {
				this.queryInfo.pageNo = 1
				this.getPageData()
			},
			getPageData:function(){
				authApi.readList(this.queryInfo).then(res=>{
					this.pageInfo = res.returnData
					// res.returnData.result.forEach(item=>{
					// 	if(item.readOnly == 0){
					// 		item.readOnly = 2
					// 	}
					// })
					this.authList = res.returnData.result
				})
			},
			//监听页码改变
			handlePageNoChange: function (pageNo) {
				this.queryInfo.pageNo = pageNo;
				this.getPageData();
			},
			// 可见设置
			setVisible: function (row) {
				this.authList.forEach(item => {
					if (row.id === item.id) {
						item.isVisible = !item.isVisible;
					}
				});
			},
			radioChange: function (val) {
				authApi.changeReadOnly({
					status:val.readOnly,
					userId:val.usid
				}).then(res=>{
					if(res.returnCode == 1001){
						this.$refs.closedProp2.show('操作成功！');
					}else {
						this.$refs.closedProp2.show('操作失败！');
					}
				})
				// console.log(val)
				// console.log(this.authList)
			}
		}
	};
</script>

<style lang="less">
.system-auth {
	padding: 10px 30px;
	height: 100%;
	.layout-div {
		background-color: #ffffff;
		min-height: 100%;
		padding: 12px 30px 20px 30px;
		.layout-div-content {
			.visible-set {
				font-size: 14px;
				letter-spacing: 1px;
				// line-height: 40px;
				margin-left: 6px;
				display: inline-block;
				margin-top: 20px;
				color: #4b414e;
				.iconfont {
					font-size: 20px;
					vertical-align: middle;
					color: #2a2f55;
					font-weight: bold;
				}
			}
			.flex-col {
				display: flex;
				align-items: center;
				justify-content: flex-end;
			}
			.table-div {
				//min-height: 410px;
				.el-radio__input{
					display: none;
				}
				.el-radio.is-checked{
					color:#0092f1;
				}
				.el-radio{
					color:#999999;
					.iconfont{
						// font-size: 18px;
						// vertical-align:middle;
					}

				}
			}
			.searchinput {
				&.el-input {
					margin-left: 22px;
					width: 426px;

					.el-input__prefix {
						top: -3px;
					}

					.el-input__inner {
						height: 40px;

						.el-input__icon.el-icon-search {
							line-height: 40px !important;
						}
					}

					.searchbtn {
						width: 100px;
						color: #fff;
						border-radius: 0px 4px 4px 0px;
						height: 40px;
						margin: -2px -20px;
						// width: 106px;
						line-height: 9px;
						line-height: 40px;
						padding: 0px;
					}
				}
			}

			.divid-line {
				background-color: #b2d2f3;
				height: 2px;
				margin: 8px 0px 26px 0px;
			}
			.btns {
				text-align: left;
				width: 70px;
				.visible {
					font-size: 14px;
					color: #60bb08;
				}
				.visibleNo {
					font-size: 14px;
					color: #0092f1;
				}
			}
			.list-footer {
				margin-top: 10px;

				.flex-center {
					display: flex;
					align-items: center;
				}

				.total-col {
					font-family: MicrosoftYaHeiLight;
					font-size: 14px;
					font-weight: normal;
					font-stretch: normal;
					letter-spacing: 0px;
					color: #4b414e;

					.total-color {
						color: #ff1414;
					}
				}
			}
		}
	}
}
</style>
